import { render } from "./index.vue?vue&type=template&id=5314bcab"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabCopyright/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5314bcab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5314bcab', __exports__)) {
    api.reload('5314bcab', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5314bcab", () => {
    api.rerender('5314bcab', render)
  })

}


export default __exports__